<div
  class="main-container my-registrations-root"
  [class.no-scroll]="isOverlayOpen || isRenewNavigationLoading"
>
  <div class="loader-overlay" *ngIf="isRenewNavigationLoading">
    <div class="loader"></div>
  </div>

  <div class="application-overlay" *ngIf="isOverlayOpen">
    <router-outlet></router-outlet>
  </div>

  <div class="my-registrations-page">
    <div class="my-registrations-header">
      <wm-common-text
        class="page-title"
        [data]="{ text: 'My Renewals' }"
      ></wm-common-text>
      <wm-common-text
        class="page-subtitle"
        [data]="{ text: 'Renewable Applications' }"
      ></wm-common-text>
    </div>

    <div class="registrations-content-card">
      <div class="registrations-toolbar">
        <wm-filter-builder
          *ngIf="filtersReady"
          id="myRenewalsFilters"
          [params]="filterCriteria"
          [defaultFilters]="defaultFilters"
          [filterTypes]="filterTypes"
          [savedFilters]="true"
          [useMuiLayout]="true"
          [keepSearchVisibleOnTopOpen]="true"
          [layoutTitle]="'Renewals'"
          [showSimpleSearch]="true"
          [simpleSearchTitle]="'Search renewals'"
          [showColumnsSettings]="false"
          [isNoData]="isNoData"
          [hasFewData]="hasFewData"
          (filtersChange)="onFiltersChanged($event)"
        >
          <ng-template #sortByTemplate>
            <div class="sort-content">
              <div class="sort-by-wrapper">
                <button
                  class="sort-btn"
                  type="button"
                  (click)="toggleSort($event)"
                >
                  Sort by |
                  <span class="selected-sort-label">{{
                    selectedSortLabel
                  }}</span>
                  <span class="material-icons dropdown-icon"
                    >keyboard_arrow_down</span
                  >
                </button>

                <div
                  class="sort-menu"
                  *ngIf="isSortOpen"
                  [class.open-above]="isSortOpenAbove"
                  (click)="$event.stopPropagation()"
                >
                  <button
                    *ngFor="let option of sortOptions"
                    class="sort-item"
                    [class.active]="option.label === selectedSortLabel"
                    type="button"
                    (click)="selectSort(option)"
                  >
                    {{ option.label }}
                  </button>
                </div>
              </div>
            </div>
          </ng-template>
        </wm-filter-builder>
      </div>

      <div class="registrations-table">
        <wm-common-table
          [tableType]="'Applicant'"
          [isLoading]="isLoading"
          [columns]="columns"
          [displayedColumns]="displayedColumns"
          [data]="data"
          [serverSidePagination]="true"
          [currentPage]="currentPage"
          [totalPages]="totalPages"
          [pageSize]="pageSize"
          [sortField]="sortField"
          [sortDescending]="sortDescending"
          (sortChanged)="onSortChanged($event)"
          (pageChange)="onPageChange($event)"
          [showRowsPerPage]="true"
          [showTotalRecords]="true"
          [totalRecords]="totalRecords"
          [pageSizeStorageKey]="'renewals-applicant-janus'"
          (rowsPerPageChange)="onRowsPerPageChange($event)"
        >
        </wm-common-table>
      </div>
    </div>
  </div>
</div>
